import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/** winepassport#348 (WP-002). */
export interface ChangeUserRoleDto {
  userId: string;
  /** 'client' | 'sommelier' */
  targetRole: string;
}

export interface UserRoleChangeResultDto {
  fromRole: string;
  toRole: string;
}

@Injectable({
  providedIn: 'root',
})
export class IdentityRoleSwitchService {
  apiName = 'Default';

  changeUserRole = (
    input: ChangeUserRoleDto,
    config?: Partial<Rest.Config>,
  ): Observable<UserRoleChangeResultDto> =>
    this.restService.request<any, UserRoleChangeResultDto>(
      { method: 'POST', url: '/api/app/identity-role-switch/change-user-role', body: input },
      { apiName: this.apiName, ...config },
    );

  constructor(private restService: RestService) {}
}
